export var aopDownloadMapper = function (data) {
    var dataEntity = {
        downloadList: [],
    };
    if (!!data && data !== "") {
        var arrayList = JSON.parse(data);
        if ((arrayList === null || arrayList === void 0 ? void 0 : arrayList.length) > 0) {
            dataEntity.downloadList = arrayList;
        }
    }
    return dataEntity;
};
